<template>
  <div class="mycheck big">
    <!--药房筛选弹窗  -->
    <el-dialog
      title="药房筛选"
      :visible.sync="checkhospital"
      width="500px"
      center
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <el-checkbox-group v-model="hospital_id">
          <el-checkbox
            :label="item.hospital_id"
            v-for="(item, index) in hospital_list"
            :key="index"
          >{{ item.hospital_name }}</el-checkbox>
        </el-checkbox-group>
        <div style="text-align: right">
          <el-button
            type="primary"
            size="medium"
            @click="checkHospital"
          >确定</el-button>
        </div>
      </div>
    </el-dialog>
    <!--  剂型筛选弹窗-->
    <el-dialog
      title="剂型筛选"
      :visible.sync="checkdrugtype"
      width="300px"
      center
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <el-checkbox-group v-model="drug_type">
          <el-checkbox
            :label="item.drug_type"
            v-for="(item, index) in drug_type_list"
            :key="index"
          >{{ item.drug_type_name }}</el-checkbox>
        </el-checkbox-group>
        <div style="text-align: right">
          <el-button
            type="primary"
            size="medium"
            @click="checkHospital"
          >确定</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="page_title">药品价格总览</div>
    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span class="searchtitle">药品名称</span>
            <el-input
              placeholder="请输入"
              v-model="drug_name"
              style="width: 150px; margin-left: 8px"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span class="searchtitle">药房筛选</span>
            <el-select
              v-model="hospital_id"
              multiple
              placeholder="请选择"
              style="width: 300px; margin-left: 8px"
              @change="changeSearch"
            >
              <el-option
                v-for="item in hospital_list"
                :key="item.value"
                :label="item.hospital_name"
                :value="item.hospital_id"
              >
              </el-option>
            </el-select>
            <!-- <el-button
              type="text"
              @click="checkhospital = true"
            >药房筛选</el-button> -->
          </div>
          <div class="item">
            <span class="searchtitle">剂型筛选</span>
            <el-select
              v-model="drug_type"
              multiple
              placeholder="请选择"
              style="width: 300px; margin-left: 8px"
              @change="changeSearch"
            >
              <el-option
                v-for="item in drug_type_list"
                :key="item.value"
                :label="item.drug_type_name"
                :value="item.drug_type"
              >
              </el-option>
            </el-select>
            <!-- <el-button
              type="text"
              @click="checkhospital = true"
            >药房筛选</el-button> -->
          </div>
          <!-- <div class="item">
            <el-button
              type="text"
              @click="checkdrugtype = true"
            >剂型筛选</el-button>
          </div> -->
          <div
            class="item"
            style="margin-left: 10px"
          >
            <el-button
              plain
              @click="resetSearch"
            >重置</el-button>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 12px;
              "
              @click="search"
            >查询</el-button>
            <el-button
              type="primary"
              @click="excelexport"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('530') : false
              "
            >导出</el-button>
          </div>
        </div>
        <div class="mytable">
          <el-table
            :data="tableData"
            v-if="titleList.length > 0"
            class="tableclass"
            height="calc(100vh - 300px)"
            :header-cell-style="{ background: '#F5F5F5', textAlign: 'center' }"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-background="rgba(0, 0, 0,0.1)"
            @sort-change="changeOrder"
          >
            <el-table-column
              fixed
              width="120"
            >
              <template slot="header">
                <div
                  style="height: 170px; line-height: 170px"
                  class="border-right"
                >
                  通用名
                </div>
              </template>
              <template slot-scope="scope">
                <div class="border-right">{{ scope.row.generic_name }}</div>
              </template>
            </el-table-column>
            <el-table-column
              v-for="(item, index) in titleList"
              :key="index"
            >
              <template slot="header">
                <div
                  style="height: 130px"
                  class="column-center border-right"
                >
                  <div style="line-height: 22px; padding-right: 10px">
                    {{ item.hospital_name }}
                  </div>
                  <div>【{{ item.drug_type_name }}】</div>
                </div>
              </template>
              <el-table-column
                label="成本价"
                sortable="custom"
                :prop="'costprice_' + item.hospital_id + '_' + item.drug_type"
              >
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row[
                        'cost_price_' + item.hospital_id + '_' + item.drug_type
                      ]
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="销售价"
                sortable="custom"
                :prop="'price_' + item.hospital_id + '_' + item.drug_type"
              >
                <template slot-scope="scope">
                  <span>
                    {{
                      scope.row[
                        'price_' + item.hospital_id + '_' + item.drug_type
                      ]
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                v-if="item.drug_type_pid == 1"
                label="成本价扣比"
                sortable="custom"
                :prop="'costkou_' + item.hospital_id + '_' + item.drug_type"
                width="110"
              >
                <template slot-scope="scope">
                  <span v-if="
                      scope.row[
                        'cost_kou_' + item.hospital_id + '_' + item.drug_type
                      ]
                    ">
                    ({{
                      Number(
                        scope.row[
                          'cost_kou_' + item.hospital_id + '_' + item.drug_type
                        ]
                      ).toFixed(2)
                    }})
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                v-if="item.drug_type_pid == 1"
                label="销售价扣比"
                sortable="custom"
                :prop="'kou_' + item.hospital_id + '_' + item.drug_type"
                width="110"
              >
                <template slot-scope="scope">
                  <span v-if="
                      scope.row[
                        'kou_' + item.hospital_id + '_' + item.drug_type
                      ]
                    ">
                    ({{
                      Number(
                        scope.row[
                          'kou_' + item.hospital_id + '_' + item.drug_type
                        ]
                      ).toFixed(2)
                    }})
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="状态"
                sortable="custom"
                :prop="'buystatus_' + item.hospital_id + '_' + item.drug_type"
                class="border-right"
              >
                <template slot="header">
                  <div style="display: inline-block">状态</div>
                </template>
                <template slot-scope="scope">
                  <div class="border-right">
                    <span
                      style="color: #669961"
                      v-if="
                        scope.row[
                          'buy_status_' +
                            item.hospital_id +
                            '_' +
                            item.drug_type
                        ] == 1
                      "
                    >
                      上架
                    </span>
                    <span
                      style="color: #e53528"
                      v-if="
                        scope.row[
                          'buy_status_' +
                            item.hospital_id +
                            '_' +
                            item.drug_type
                        ] == 2
                      "
                    >
                      下架
                    </span>
                    <span v-if="
                        !scope.row[
                          'buy_status_' +
                            item.hospital_id +
                            '_' +
                            item.drug_type
                        ]
                      ">
                      未添加
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="price10">
              <template slot="header">
                <div style="height: 170px; line-height: 170px">2010价</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import Pagination from '@/components/Pagination';
export default {
  inject: ['reload'],
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      tableData: [],
      titleList: [],
      pagination: {
        page: 1,
        pageNumber: 10
      },
      drug_name: '',
      hospital_id: [],
      drug_type: [1],
      order_type: 0,
      order_hospital_id: '',
      order_drug_type: '',
      hospital_list: [],
      drug_type_list: [],
      loading: true,
      checkhospital: false,
      checkdrugtype: false
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getDrugTypeList();
    this.getHospital();
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      this.loading = true;
      let arr = JSON.parse(JSON.stringify(this.titleList)) || [];
      this.titleList = [];
      let data = {
        hospital_id: this.hospital_id.toString(),
        drug_type: this.drug_type.toString(),
        drug_name: this.drug_name,
        page: this.pagination.page,
        pageNumber: this.pagination.pageNumber,
        order_type: this.order_type,
        order_hospital_id: this.order_hospital_id,
        order_drug_type: this.order_drug_type
      };
      this.axios
        .post('platform/hospital/getHospitalDrugTotal', data)
        .then((res) => {
          if (!res.data.title.length) {
            this.loading = false;
            this.$message.info('暂无数据,请重新筛选');
            this.titleList = arr;
            return false;
          }
          this.totalNum = res.data.total;
          this.titleList = res.data.title;
          this.tableData = res.data.list;
          this.loading = false;
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop_arr = value.prop.split('_');
      let prop = prop_arr[0];
      this.order_hospital_id = prop_arr[1];
      this.order_drug_type = prop_arr[2];
      //升序
      if (order == 'ascending') {
        if (prop == 'price') {
          this.order_type = 1;
        } else if (prop == 'kou') {
          this.order_type = 3;
        } else if (prop == 'buystatus') {
          this.order_type = 5;
        } else if (prop == 'costprice') {
          this.order_type = 7;
        } else if (prop == 'costkou') {
          this.order_type = 9;
        }
      }
      //降序
      if (order == 'descending') {
        if (prop == 'price') {
          this.order_type = 2;
        } else if (prop == 'kou') {
          this.order_type = 4;
        } else if (prop == 'buystatus') {
          this.order_type = 6;
        } else if (prop == 'costprice') {
          this.order_type = 8;
        } else if (prop == 'costkou') {
          this.order_type = 10;
        }
      }
      if (!order) {
        this.order_type = 0;
        this.order_hospital_id = '';
        this.order_drug_type = '';
      }
      this.getList();
    },
    //药房剂型筛选
    checkHospital() {
      this.getList();
      this.checkhospital = false;
      this.checkdrugtype = false;
    },
    //获取药房列表
    getHospital() {
      this.axios
        .post('platform/hospital/getHospitaList', {
          page: 1,
          pageNumber: 10000
        })
        .then((res) => {
          this.hospital_list = res.data.list.map((item) => {
            item = _.pick(item, ['hospital_id', 'hospital_name']);
            return item;
          });
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post('platform/photograph/getDrugTypeList', { platform_type })
        .then((res) => {
          this.drug_type_list = res.data.list;
        });
    },
    //导出数据
    excelexport() {
      let loading = this.$loading();
      let data = {
        hospital_id: this.hospital_id.toString(),
        drug_type: this.drug_type.toString(),
        drug_name: this.drug_name,
        order_type: this.order_type,
        order_hospital_id: this.order_hospital_id,
        order_drug_type: this.order_drug_type
      };
      this.axios
        .post('platform/hospital/exporHospitalDrugTotal', data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              '//' +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    search() {
      this.pagination.page = 1;
      this.getList();
    },
    changeSearch() {
      if (!this.drug_type.length) {
        return false;
      }
      this.order_type = 0;
      this.order_hospital_id = '';
      this.order_drug_type = '';
      this.getList();
    },
    resetSearch() {
      this.drug_name = '';
      this.drug_type = [1];
      this.hospital_id = [];
      this.order_type = 0;
      this.order_hospital_id = '';
      this.order_drug_type = '';
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 16px;
  .searchtitle {
    display: inline-block;
    width: 60px;
    text-align: right;
    box-sizing: border-box;
  }
  .item {
    margin-right: 10px;
    margin-top: 16px;
    display: flex;
    align-items: center;
  }
}
.border-right {
  border-right: 1px solid #acacac;
}
</style>
<style lang="scss">
.mycheck .el-checkbox-group {
  display: flex;
  flex-direction: column;
  .el-checkbox {
    margin-bottom: 4px;
  }
}
</style>
<style>
.mytable .el-table .cell {
  line-height: 40px;
  padding-right: 0px;
  width: 100%;
  height: 100%;
  /* border-right: 1px solid #acacac; */
}
.mytable .el-table th,
.el-table td {
  padding: 0;
}
</style>


